var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10782_74188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.14461 7.70715C0.754083 7.31662 0.754083 6.68346 1.14461 6.29293L6.29293 1.14461C6.68346 0.754083 7.31662 0.754082 7.70715 1.14461L12.8555 6.29293C13.246 6.68346 13.246 7.31662 12.8555 7.70715L7.70715 12.8555C7.31662 13.246 6.68346 13.246 6.29293 12.8555L1.14461 7.70715Z",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73926 2.69824L6.27809 4.23708",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60449 7.58333C8.60449 7.71739 8.6309 7.85014 8.6822 7.97399C8.7335 8.09784 8.80869 8.21038 8.90349 8.30517C8.99828 8.39996 9.11082 8.47516 9.23467 8.52646C9.35852 8.57776 9.49127 8.60417 9.62533 8.60417C9.75938 8.60417 9.89213 8.57776 10.016 8.52646C10.1398 8.47516 10.2524 8.39996 10.3472 8.30517C10.442 8.21038 10.5172 8.09784 10.5685 7.97399C10.6198 7.85014 10.6462 7.71739 10.6462 7.58333C10.6462 7.44928 10.6198 7.31653 10.5685 7.19268C10.5172 7.06882 10.442 6.95629 10.3472 6.8615C10.2524 6.7667 10.1398 6.69151 10.016 6.64021C9.89213 6.5889 9.75938 6.5625 9.62533 6.5625C9.49127 6.5625 9.35852 6.5889 9.23467 6.64021C9.11082 6.69151 8.99828 6.7667 8.90349 6.8615C8.80869 6.95629 8.7335 7.06882 8.6822 7.19268C8.6309 7.31653 8.60449 7.44928 8.60449 7.58333Z",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97949 9.91634C5.97949 10.1871 6.08704 10.4467 6.27849 10.6382C6.46993 10.8296 6.72958 10.9372 7.00033 10.9372C7.27107 10.9372 7.53072 10.8296 7.72216 10.6382C7.91361 10.4467 8.02116 10.1871 8.02116 9.91634C8.02116 9.6456 7.91361 9.38595 7.72216 9.1945C7.53072 9.00306 7.27107 8.89551 7.00033 8.89551C6.72958 8.89551 6.46993 9.00306 6.27849 9.1945C6.08704 9.38595 5.97949 9.6456 5.97949 9.91634Z",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97949 4.95833C5.97949 5.22908 6.08704 5.48873 6.27849 5.68017C6.46993 5.87161 6.72958 5.97917 7.00033 5.97917C7.27107 5.97917 7.53072 5.87161 7.72216 5.68017C7.91361 5.48873 8.02116 5.22908 8.02116 4.95833C8.02116 4.68759 7.91361 4.42794 7.72216 4.2365C7.53072 4.04505 7.27107 3.9375 7.00033 3.9375C6.72958 3.9375 6.46993 4.04505 6.27849 4.2365C6.08704 4.42794 5.97949 4.68759 5.97949 4.95833Z",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72168 5.67969L8.90351 6.86152",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5.97949V8.89616",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10782_74188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitLogo);
export default __webpack_public_path__ + "static/media/Git Logo.32696780.svg";
export { ForwardRef as ReactComponent };